import React, { useEffect } from "react";
import * as S from "./styled";
import FloatingKakaoIcon from "../../assets/images/home/home-floating-kakao.png";

import FloatingBanner from "../../components/FloatingBanner";
import { NavLink } from "react-router-dom";
import { instructorsDetailList } from "../../data/instructors";
import AOS from "aos";
import { Helmet } from "react-helmet-async";

const Instructors = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      AOS.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>넵튠 댄스 스튜디오 | 셔플 풋워크 전문 학원</title>

        <meta
          name="description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />

        <meta
          name="keywords"
          content="넵튠, 넵튠 댄스, 넵튠 댄스 스튜디오, 셔플, 셔플댄스학원, 댄스자격증, 풋워크 수업, 국제실용댄스지도자협회, 국제실용댄스, 풋워크"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://neptunedance.com" />
        <meta
          property="og:image"
          content="https://neptunedance.com/og-image.png"
        />
      </Helmet>
      <S.InstructorsItemWrapper>
        <div className="inner">
          <S.InstructorsItemWrap>
            <div className="title-wrap">
              <h3
                data-aos="fade-right"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                INSTRUCTORS
              </h3>
              <p
                data-aos="fade-right"
                data-aos-delay={200}
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                강사진 소개
              </p>
            </div>
            <S.InstructorsItemListWrap>
              {instructorsDetailList.map((instructor, index) => (
                <S.InstructorsItem
                  key={instructor.name}
                  data-aos="fade-up"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  <NavLink to={instructor.name}>
                    <div className="img-area">
                      <div className="img-area-dim" />
                      <img src={instructor.img} alt={instructor.name} />
                      <p className="img-sub-text">{instructor.name}</p>
                    </div>
                    <div className="text-wrap">
                      <h6>{instructor.name}</h6>
                      <p>{instructor.genre}</p>
                    </div>
                  </NavLink>
                </S.InstructorsItem>
              ))}
            </S.InstructorsItemListWrap>
          </S.InstructorsItemWrap>
        </div>

        <FloatingBanner
          linkTo="http://pf.kakao.com/_xdxcJZn"
          icon={FloatingKakaoIcon}
          text="상담 문의"
          target="_blank"
        />
      </S.InstructorsItemWrapper>
    </>
  );
};

export default Instructors;
